import { render } from "./ParticipantFields.vue?vue&type=template&id=3f16634c&ts=true"
import script from "./ParticipantFields.vue?vue&type=script&lang=ts"
export * from "./ParticipantFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__